/**
 * Content Security Policy (CSP) Configuration for Dynatrace RUM
 *
 * This file contains recommended CSP directives to allow Dynatrace RUM to function properly.
 * Add these directives to your web server configuration or meta tags.
 */

/**
 * Recommended CSP Directives for Dynatrace RUM
 */
export const DYNATRACE_CSP_DIRECTIVES = {
	/**
	 * Allow Dynatrace scripts from CDN
	 * Required for loading the RUM JavaScript agent
	 */
	scriptSrc: [
		'\'self\'',
		'https://js-cdn.dynatrace.com',
		// If using inline script with dynamic configuration
		'\'unsafe-inline\'', // Consider using nonce-based CSP instead
	],

	/**
	 * Allow connections to Dynatrace beacon endpoints
	 * Required for sending RUM data
	 */
	connectSrc: [
		'\'self\'',
		'https://*.bf.dynatrace.com',
		'https://*.dynatrace.com',
	],

	/**
	 * Allow Dynatrace images (if using Session Replay)
	 * Required for session replay screenshots
	 */
	imgSrc: ['\'self\'', 'data:', 'https://*.dynatrace.com'],

	/**
	 * Allow inline styles (often needed for dynamic content)
	 */
	styleSrc: ['\'self\'', '\'unsafe-inline\''],
};

/**
 * Format CSP directives as a string for meta tags
 * @returns CSP directive string
 */
export const formatDynatraceCspAsString = (): string => {
	const directives: string[] = [];

	Object.entries(DYNATRACE_CSP_DIRECTIVES).forEach(([directive, sources]) => {
		const directiveName = directive
			.replace(/([A-Z])/g, '-$1')
			.toLowerCase();
		directives.push(`${directiveName} ${sources.join(' ')}`);
	});

	return directives.join('; ');
};
